<!-- filepath: /workspaces/books/src/components/PrivacyPolicyModal.vue -->
<template>
  <div class="privacy-policy-overlay" @click.self="$emit('close')">
    <div class="privacy-policy-container">
      <div class="privacy-policy-header">
        <h2>プライバシーポリシー</h2>
        <button class="close-button" @click="$emit('close')">×</button>
      </div>
      
      <div class="privacy-policy-body">
        <iframe 
          src="https://txt365.org/privacy-policy/"
          class="privacy-iframe"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      
      <div class="privacy-policy-buttons">
        <button class="close-button-bottom" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyModal'
}
</script>

<style scoped>
.privacy-policy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}

.privacy-policy-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.privacy-policy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.privacy-policy-header h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.privacy-policy-body {
  padding: 0;
  overflow: hidden;
  flex-grow: 1;
  min-height: 60vh;
}

.privacy-iframe {
  width: 100%;
  height: 100%;
  min-height: 60vh;
  border: none;
}

.privacy-policy-buttons {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

.close-button-bottom {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 8px 25px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-button-bottom:hover {
  background-color: #d9b6ab;
}
</style>